import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { usePrevious } from "../../../helper/CustomHook";
import { metadataEditSchema } from "../../../helper/yup-schema";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import logo from '../../../assets/images/brand_icons/upids-pdm-logo.png'
import { BiTrash } from "react-icons/bi";
import { MdArrowBack, MdMenu, MdOutlineModeEdit, MdOutlineSave, MdOutlineClose } from "react-icons/md";
import { StMenu } from "src/components/StMenu";
import { IconButton } from "src/components/IconButton"
import { StCloseButton } from "src/components/StCloseButton";
import { StSquareButton } from "src/components/StSquareButton";
import { StCancelSquareButton } from "src/components/StCancelSquareButton";
import { changeTaxonomyEditModeAction, taxonomyAllErrorsEditFormObject } from "src/redux/products/productsSlice";
import { deleteTaxonomyItem, editTaxonomyData, getTaxonomyDataByIdAction } from "src/redux/products/productThunk";

const MetadataProfileNavbar = () => {

    const userProfileNavbarCollection = [
        {
            menuItem: () => <IconButton text={t("Edit")} icon={MdOutlineModeEdit} onClick={() => changeMode()} />,
            submenu: [
                { menuItem: () => <IconButton text={t("Save Changes")} icon={MdOutlineSave} onClick={() => handleSaveClick()} /> },
                { menuItem: () => <IconButton text={t("Delete Taxonomy")} icon={BiTrash} onClick={() => handleDeleteClick()} /> },
                { menuItem: () => <IconButton text={t("Cancel")} icon={MdOutlineClose} onClick={() => handleCancelClick()} /> }
            ],
            submenuTitle: () => <IconButton text={t("Edit")} icon={MdOutlineModeEdit} onClick={() => changeMode()} />
        },
    ]

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let { id } = useParams();
    const { t } = useTranslation('common');
    const [show, setShow] = useState(false);
    const _state = useSelector((state) => state.products, shallowEqual);

    const [showDelPopup, setShowDelPopup] = useState(false);
    const data = _state.currentTaxonomyObj;
    const { editTaxonomyResponse, deleteTaxonomyResponse } = _state;

    function toggleOffcanvas() {
        document.querySelector(".sidebar-offcanvas").classList.toggle("active");
    }
    const changeMode = () => {
        dispatch(changeTaxonomyEditModeAction(true));
    };

    const handleClose = () => setShow(false);

    let allErrors;
    const handleSaveClick = () => {
        metadataEditSchema
            .validate(data, { abortEarly: false })
            .then(function () {
                dispatch(taxonomyAllErrorsEditFormObject([]));
            })
            .then(function () {
                setShow(true);
            })
            .catch(function (err, inner) {
                allErrors = err.inner;
                dispatch(taxonomyAllErrorsEditFormObject(allErrors));
            });
    };

    const handleDeleteClick = () => {
        setShowDelPopup(true);
    };

    const handleCancelClick = async () => {
        dispatch(changeTaxonomyEditModeAction(false));
        await dispatch(getTaxonomyDataByIdAction(id));



    }

    const handleDelClose = () => setShowDelPopup(false);

    const handleSaveChanges = async () => {
        try {
            await dispatch(editTaxonomyData({ body: data }));
            await dispatch(changeTaxonomyEditModeAction(false));
            setShow(false)
        } catch (error) {
            console.log(error)
        }
    }

    const handleDeleteChanges = async () => {
        try {
            // setDeleteTaxonomyItemLoader(true);
            await dispatch(deleteTaxonomyItem(location?.state?.metadata?.id));
            // setDeleteTaxonomyItemLoader(false)
            navigate("/metadata")
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <>
            <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
                <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                    <Link className="navbar-brand brand-logo" to="/dashboard">
                        <img src={logo} alt="logo" />
                    </Link>
                    <Link
                        className="navbar-brand brand-logo-mini d-inline-block d-lg-none"
                        to="/"
                    >
                        <img
                            src={require("../../../assets/images/logo-mini.svg")}
                            alt="logo"
                        />
                    </Link>
                </div>
                <div className="navbar-menu-wrapper d-flex align-items-center">
                    <span className="back-arrow-span">
                        <MdArrowBack
                            className="back-arrow"
                            onClick={() => navigate(-1)}
                        />
                        <Trans></Trans>
                    </span>
                    <span className="user-profile-text">{t("Metadata Profile")}</span>
                    <span className="horizontal-line"></span>
                    <span className="full-user-name">{!!data ? data?.attributeName : ''}</span>

                    {!_state.isTaxonomyEditMode ? (
                        <div className="navbar-nav navbar-nav-right d-none d-sm-flex">
                            <IconButton
                                text={t("Edit")}
                                icon={MdOutlineModeEdit}
                                onClick={changeMode}
                            />
                        </div>
                    ) : (
                        <div className="navbar-nav navbar-nav-right d-none d-sm-flex">
                            <IconButton
                                text={t("Save Changes")}
                                icon={MdOutlineSave}
                                onClick={handleSaveClick}
                            />
                            <IconButton
                                text={t("Delete Taxonomy")}
                                icon={BiTrash}
                                onClick={handleDeleteClick}
                            />
                            <IconButton
                                text={t("Cancel")}
                                icon={MdOutlineClose}
                                onClick={handleCancelClick}
                            />
                        </div>
                    )}

                    {/* responsive dropdown on mobile screen */}
                    <ul className="navbar-nav navbar-nav-right productNavResponsiveDropdown">
                        <StMenu menuArray={userProfileNavbarCollection}></StMenu>
                    </ul>

                    <button
                        className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                        type="button"
                        onClick={toggleOffcanvas}
                    >
                        <MdMenu color="#000000" size={24} />
                    </button>
                </div>
            </nav>

            <Modal size="md" show={show} onHide={handleClose} centered={true}>
                <Modal.Header >
                    <div style={{ position: 'absolute', right: 10 }}>
                        <StCloseButton text={t("Close")} onClick={() => handleClose()}></StCloseButton>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ display: 'block', padding: 50, textAlign: 'center', color: '#131e27', opacity: 1, fontWeight: 'bold', fontSize: 18, }}>
                    <span >{t("Are you sure want to save the changes")}</span>
                </Modal.Body>
                <Modal.Footer>
                    <StSquareButton text={t("Save Changes")} onClick={() => handleSaveChanges()} loading={_state.isLoading ? true : false} disabled={false}></StSquareButton>
                    <StCancelSquareButton text={t("Discard")} onClick={() => handleClose()}></StCancelSquareButton>
                </Modal.Footer>
            </Modal>

            <Modal size="md" show={showDelPopup} onHide={handleDelClose} centered={true}>
                <Modal.Header >
                    <div style={{ position: 'absolute', right: 10 }}>
                        <StCloseButton text={t("Close")} onClick={() => handleDelClose()}></StCloseButton>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ display: 'block', padding: 50, textAlign: 'center', color: '#131e27', opacity: 1, fontWeight: 'bold', fontSize: 18, }}>
                    <span>{t("Are you sure want to delete the taxonomy item")}</span>
                </Modal.Body>
                <Modal.Footer>
                    <StSquareButton text={t("Yes")} onClick={() => handleDeleteChanges()} loading={_state?.isLoading ? true : false} disabled={false}></StSquareButton>
                    <StCancelSquareButton text={t("No")} onClick={() => handleDelClose()}></StCancelSquareButton>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default MetadataProfileNavbar;
